export enum pageTypes {}

export enum deviceTypes {
  MSITE = "mweb",
  DESKTOP = "dweb",
}

export enum pageNamePrefix {
  PAYMENT = ":PaymentPage",
}

// ? Picked up these from nykaa_fe
export const events = {
  PAYMENT_LOAD: "PAYMENT_LOAD",
  CHECKOUT_EXPERIMENTS: "CHECKOUT_EXPERIMENTS",
  USER_DATA: "USER_DATA",
  POST_PAYMENT_STATUS: "POST_PAYMENT_STATUS",
  SHIPPING_ADDRESS_WIDGET_LOAD: "SHIPPING_ADDRESS_WIDGET_LOAD",
  PAYMENT_PAY_NOW: "PAYMENT_PAY_NOW",
  OTHER_PAYMENT_CLICK: "OTHER_PAYMENT_CLICK",
  PAYMENT_METHOD_CLICK: "PAYMENT_METHOD_CLICK",
  PAYMENT1_PAGE_LOAD: "PAYMENT1_PAGE_LOAD",
  PAYMENT2_PAGE_LOAD: "PAYMENT2_PAGE_LOAD",
  DESKTOP_PAYMENT_PAGE_LOAD: "DESKTOP_PAYMENT_PAGE_LOAD",
  PAYMENT_PAY_NOW_FAILURE: "PAYMENT_PAY_NOW_FAILURE",
  TRACK_BANK_CARD_VALID_FOR_OFFER: "TRACK_BANK_CARD_VALID_FOR_OFFER",
  TRACK_BANK_CARD_BIN_INVALID: "TRACK_BANK_CARD_BIN_INVALID",
  TRACK_BANK_CARD_ALREADY_USED: "TRACK_BANK_CARD_ALREADY_USED",
  SAVED_ADDRESS_PAGE_LOAD: "SAVED_ADDRESS_PAGE_LOAD",
  EDIT_ADDRESS_CLICK: "EDIT_ADDRESS_CLICK",
  ADD_NEW_ADDRESS_CLICK: "ADD_NEW_ADDRESS_CLICK",
  SHIP_ADDRESS_CLICK: "SHIP_ADDRESS_CLICK",
  SAVE_ADDRESS_CLICK: "SAVE_ADDRESS_CLICK",
  NEW_ADDRESS_PAGE_LOAD: "NEW_ADDRESS_PAGE_LOAD",
  NEW_PAYMENT_SUCCESS_PAGE_LOAD: "NEW_PAYMENT_SUCCESS_PAGE_LOAD",
  AUTO_DETECT_CLICK: "AUTO_DETECT_CLICK",
  AUTO_DETECT_CONFIRM_CLICK: "AUTO_DETECT_CONFIRM_CLICK",
  ERROR_CONTINUE_CLICK: "ERROR_CONTINUE_CLICK",
  USE_DEFAULT_ADDRESS_TOGGLE_CLICK: "USE_DEFAULT_ADDRESS_TOGGLE_CLICK",
  TRACK_PAYMENT_DETAIL_CLICK: "TRACK_PAYMENT_DETAIL_CLICK",
  WALLET_OTP_LOAD: "WALLET_OTP_LOAD",
  WALLET_OTP_INTERACTIONS: "WALLET_OTP_INTERACTIONS",
  LATIN_CHARACTERS_DETECTED: "LATIN_CHARACTERS_DETECTED",
  USER_CONSENT_CHECKBOX_CHECKED: "USER_CONSENT_CHECKBOX_CHECKED",
  USER_CONSENT_KNOW_MORE_CLICKED: "USER_CONSENT_KNOW_MORE_CLICKED",
  USER_CONSENT_BUTTON_CLICKED: "USER_CONSENT_BUTTON_CLICKED",
  CHECK_CLICKED_ON_DELIVEERY_TOAST: "CHECK_CLICKED_ON_DELIVEERY_TOAST",
  EDD_WIDGET_DROPDOWN_CLICK: "EDD_WIDGET_DROPDOWN_CLICK",
  COD_NUDGE_VISIBLE: "COD_NUDGE_VISIBLE",
  COD_NUDGE_CLICK: "COD_NUDGE_CLICK",
  BACK_FRICTION_SCREEN_RENDER: "BACK_FRICTION_SCREEN_RENDER",
  BACK_FRICTION_CONTINUE_WITH_PAYMENT: "BACK_FRICTION_CONTINUE_WITH_PAYMENT",
  BACK_FRICTION_CANCEL_PAYMENT: "BACK_FRICTION_CANCEL_PAYMENT",
  ERROR_PAGE_LOADS: "ERROR_PAGE_LOADS",
  ERROR_INLINE_MESSAGE: "ERROR_INLINE_MESSAGE",
  MY_SAVED_PAYMENT_PAGE_LOAD: "MY_SAVED_PAYMENT_PAGE_LOAD",
  POST_PAYMENT_SUCCESS: "POST_PAYMENT_SUCCESS",
  POST_PAYMENT_FALIURE: "POST_PAYMENT_FALIURE",
  PAYMENT_PAGE_BACK_BUTTON_CLICK: "PAYMENT_PAGE_BACK_BUTTON_CLICK",
  PROCEED_TO_PAY: "PROCEED_TO_PAY",
  AUTO_REDIRECT_TO_PAYMENT2_PAGE: "AUTO_REDIRECT_TO_PAYMENT2_PAGE",
  ORDER_ITEM_PLACED: "ORDER_ITEM_PLACED",
  APP_CALLBACK_FAILED: "APP_CALLBACK_FAILED",
  APP_CALLBACK_SUCCESS: "APP_CALLBACK_SUCCESS",
  CUSTOMER_ID_MISMATCHED: "CUSTOMER_ID_MISMATCHED",
  CART_NOT_FOUND: "CART_NOT_FOUND",
  DATALAYER_DEVICE_TYPE: "DATALAYER_DEVICE_TYPE",
  API_RESPONSE_TIME: "apiResponseTime",
  ADDRESS_BACK_BOTTOMSHEET_LOADS: "ADDRESS_BACK_BOTTOMSHEET_LOADS",
  ADDRESS_BACK_BOTTOMSHEET_CLICK: "ADDRESS_BACK_BOTTOMSHEET_CLICK",
  CHECKOUT_STATUS: "CHECKOUT_STATUS",
  BANNER_CLICKED: "banner_clicked",
  HOME_PAGE_LOADS : "home_page_loads", 
  CHAT_SUPPORT_CLICK : "help_support_click",  
  CALL_ASSISTANCE_CLICK : "call_assistance_click",  
  OCP_ORDER_DETAILS_BS_LOADS : "ocp_order_details_bs_loads",  
  ORDER_CONFIRMATION_PAGE_LOADS : "order_confirmation_page_loads", 
  /**
   *  SAVED_PAYMENT_METHODS, FRESH_PAYMENT_METHODS, WEBVIEW_ORDER_CREATED -- used for pushing data to GA4
   */
  SAVED_PAYMENT_METHODS: "SAVED_PAYMENT_METHODS",
  FRESH_PAYMENT_METHODS: "FRESH_PAYMENT_METHODS",
  WEBVIEW_ORDER_CREATED: "WEBVIEW_ORDER_CREATED",
  INTERNAL_USER: "INTERNAL_USER",

  PAYMENT_ERROR_POPUP: "PAYMENT_ERROR_POPUP",
  PAYMENT_ERROR_POPUP_CLICK: "PAYMENT_ERROR_POPUP_CLICK",
  PAYMENT_OFFER_WIDGET_CLICK: "payment_offer_widget_click",
  PAYMENT_OFFER_CLICKED: "PAYMENT_OFFER_CLICKED",
  ADD_NEW_ADDRESS_REDIRECTION: "ADD_NEW_ADDRESS_REDIRECTION",
  PAYMENT_PAGE_LOADED_TIME: "PAYMENT_PAGE_LOADED_TIME",

  ADD_MONEY_PAYTM: "ADD_MONEY_PAYTM",
  WEBVIEW_TAB_ACTIVE: "webview_tab_active",
  WEBVIEW_TAB_INACTIVE: "webview_tab_inactive",
  MEMORY_LEAK: "memory_leak",
  UPI_INTENT_ERROR_MWEB: "UPI_INTENT_ERROR_MWEB",
  UPI_INTENT_CANCEL_CLICK: "upi_intent_cancel_click",
  UPI_CANCEL_PAYMENT_CLICK: "upi_cancel_payment_click",
  CANCEL_UPI_POP_UP_ACTION: "cancel_upi_popup_action",
  QR_GENERATE_NEW: "qr_generate_new",
  QR_CHOOSE_ANOTHER_METHOD: "qr_choose_another_method",
  QR_EXPIRED: "qr_expired",
  CHANGE_OR_ADD_ADDRESS_CLICKED: "change_or_add_address_clicked",
  EDIT_ADDRESS_LOADS: "edit_address_loads",
  ADDRESS_BACK_BUTTON_CLICKED: "address_back_button_clicked",
  PINCODE_NON_SERVICEABLE: "pincode_nonserviceable",
  SHIP_TO_ADDRESS_CLICKS_ERROR: "ship_to_address_clicks_error",
  PRECONFIRMATION_LOAD: "PRECONFIRMATION_LOAD",
  PRECONFIRMATION_RETRY_CLICK: "RETRY_PAYMENT",
  REMOVE_COUPON_CLICK: "REMOVE_COUPON_CLICK",
  KEEP_COUPON_CLICK: "KEEP_COUPON_CLICK",
  RETRY_WALLET_CLICK: "RETRY_WALLET_CLICK",
  GIFT_CARD_PAYMENT_PAGE_LOAD: "gift_card_payment_page_loads",
  ADD_ADDRESS_BOTTOM_SHEET_LOADS: "add_address_bottomsheet_loads",
  ADD_ADDRESS_BOTTOM_SHEET_CLOSED: "add_address_bottomsheet_closed",
  ADD_ADDRESS_BOTTOM_SHEET_CLICKED: "add_address_bottomsheet_clicked",
  IMPORT_CTA_CLICKED: "import_cta_clicked",
  IMPORT_ADDRESS_PAGE_LOADS: "import_address_page_loads",
  IMPORT_ADDRESS_CLICKED: "import_address_clicked",
  ADDRESS_IMPORTED: "address_imported",
  ADDRESS_IMPORTED_SUCCESS: "address_imported_success",
  ADDRESS_AUTO_DETECT_FAILURE: "address_auto_detect_failure",
  PAYMENT_BOTTOMSHEET_LOADS: "payment_bottomsheet_loads", 
  AUTO_ORDER_CONFIRMATION_PAGE: "auto_order_confirmation_page",
  AUTO_ORDER_CONFIRMATION_BOTTOMSHEET: "auto_order_confirmation_bottomsheet",
  AUTO_ORDER_CANCEL_BTN_CLICKED: "auto_order_cancel_btn_clicked",
  AUTO_ORDER_CONFIRM_BTN_CLICKED: "auto_order_confirm_btn_clicked",
  OTHER_UPI_CLICK: "other_upi_click",
  UPI_AVAILABILITY: "upi_availibility",
};

// payment methods set in datalayer for tracking
export const PAYMENT_METHODS_DATALAYER = {
  CC: "Card",
  NB: "nb",
  UPI: "upi",
  GC: "gc",
  WALLET: "wallet",
  PAYTM: "paytm",
  COD: "COD",
  SAVED_CC: "SavedCard",
  SAVED_SIMPL: "simplSaved",
  UPI_INTENT: "UpiIntent",
  GOOGLE_PAY: "googlePay",
  GOOGLE_PAY_INTENT: "GooglePayIntent",
  EMI: "EMI",
  ZEST: "Zest",
  SHOP_NOW_PAY_LATER: "ShopNowPayLater",
  SIMPL: "Simpl",
  CRED: "cred pay",
  QR: "QR",
};

export const SAVED_DETAIL = "SavedDetail";
export const FRESH_PAYMENT = "FreshPayment";
export const EC_DELAY_SCREEN = "express_checkout:delayScreen";


export const NO_SAVED_METHOD = "no saved method";
export const NO_OTHER_METHOD = "no other method";

export const VARIANT_A = "A";
export const VARIANT_B = "B";
export const VARIANT_C = "C";
export const VARIANT_D = "D";
export const VARIANT_E = "E";

export const SAVED_PAGE = "savedPage";
export const ALL_PAGE = "allPage";

export const WALLET_OTP_STATES = {
  RESEND: "Resend",
  SUCCESS: "complete",
  FAIL: "fail",
};

export const NEW_PAYMENT_METHODS_DATALAYER = {
  UPI_COLLECT: "upi_collect",
  UPI_INTENT: "upi_intent",
  CREDIT_CARD: "credit_card",
  DEBIT_CARD: "debit_card",
  CRED_PAY: "cred_pay",
  SIMPL: "simpl",
  COD: "cod",
  NET_BANKING: "netbanking",
  EMI: "emi",
  GIFT_CARD: "giftcard",
  WALLET: "nykaa_wallet",
  UPI_QR: "QR",
};
